import React from 'react';
import { useNavigate } from 'react-router-dom';

function PrivacyPolicy() {
  const navigate = useNavigate();

  const Section = ({ title, children }) => (
    <div style={{ marginBottom: '32px' }}>
      <div style={{
        fontFamily: 'Bebas Neue, sans-serif', fontSize: '20px',
        letterSpacing: '2px', color: '#ff3c00', marginBottom: '12px'
      }}>
        {title}
      </div>
      <div style={{ color: '#a0a0a0', fontSize: '14px', lineHeight: '1.8' }}>
        {children}
      </div>
    </div>
  );

  return (
    <div style={{ background: '#080808', minHeight: '100vh', color: '#f0f0f0', fontFamily: 'DM Sans, sans-serif', paddingBottom: '60px' }}>

      {/* NAVBAR */}
      <nav style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100,
        padding: '16px 24px', display: 'flex', alignItems: 'center',
        gap: '16px', background: 'rgba(8,8,8,0.9)',
        backdropFilter: 'blur(12px)', borderBottom: '1px solid #242424'
      }}>
        <button onClick={() => navigate(-1)} style={{
          background: '#1c1c1c', border: '1px solid #242424', borderRadius: '8px',
          padding: '8px 14px', color: '#f0f0f0', fontSize: '16px', cursor: 'pointer'
        }}>
          ←
        </button>
        <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '22px', letterSpacing: '3px' }}>
          FIT<span style={{ color: '#ff3c00' }}>OFF</span>
        </div>
      </nav>

      {/* HEADER */}
      <div style={{ marginTop: '62px', padding: '40px 24px 24px', borderBottom: '1px solid #242424' }}>
        <div style={{
          display: 'inline-flex', alignItems: 'center', gap: '6px',
          background: 'rgba(255,60,0,0.12)', border: '1px solid rgba(255,60,0,0.25)',
          borderRadius: '100px', padding: '4px 12px', fontSize: '12px',
          color: '#ff3c00', marginBottom: '16px', letterSpacing: '1px', textTransform: 'uppercase'
        }}>
          Legal
        </div>
        <h1 style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '48px', letterSpacing: '2px', lineHeight: '1', marginBottom: '12px' }}>
          PRIVACY POLICY
        </h1>
        <p style={{ color: '#606060', fontSize: '13px' }}>
          Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
        </p>
      </div>

      {/* CONTENT */}
      <div style={{ padding: '32px 24px' }}>

        <Section title="Overview">
          Fitoff ("we," "us," or "our") operates fitoff.store, a clearance deal aggregator that helps users discover discounted products from major retail brands. This Privacy Policy explains how we collect, use, and protect your information when you use our website.
          <br /><br />
          By using Fitoff, you agree to the collection and use of information in accordance with this policy.
        </Section>

        <Section title="Affiliate Disclosure">
          Fitoff participates in affiliate marketing programs. This means we earn a commission when you click on links to partner brands and make a purchase — at no additional cost to you.
          <br /><br />
          We are an affiliate partner with the following networks:
          <ul style={{ marginTop: '10px', paddingLeft: '20px', lineHeight: '2' }}>
            <li><strong style={{ color: '#f0f0f0' }}>CJ Affiliate (Commission Junction)</strong> — cj.com</li>
            <li><strong style={{ color: '#f0f0f0' }}>Awin</strong> — awin.com</li>
            <li><strong style={{ color: '#f0f0f0' }}>Impact</strong> — impact.com</li>
          </ul>
          <br />
          These networks and their advertiser partners may use cookies and tracking technologies to attribute purchases to our referrals. Our editorial content and deal selection are not influenced by affiliate relationships — we only feature deals we believe offer genuine value.
        </Section>

        <Section title="Information We Collect">
          <strong style={{ color: '#f0f0f0' }}>Information you provide:</strong> We do not currently require account creation or collect personal information such as your name or email address to browse deals on Fitoff.
          <br /><br />
          <strong style={{ color: '#f0f0f0' }}>Automatically collected information:</strong> When you visit Fitoff, we may automatically collect certain information including:
          <ul style={{ marginTop: '10px', paddingLeft: '20px', lineHeight: '2' }}>
            <li>Browser type and version</li>
            <li>Pages visited and time spent on those pages</li>
            <li>Referring URL (how you found us)</li>
            <li>Device type and operating system</li>
            <li>IP address (used for general geographic analytics only)</li>
          </ul>
        </Section>

        <Section title="Cookies & Tracking">
          Fitoff and our affiliate partners use cookies — small text files stored on your device — to:
          <ul style={{ marginTop: '10px', paddingLeft: '20px', lineHeight: '2' }}>
            <li>Track affiliate referrals so we receive credit for purchases you make</li>
            <li>Remember your preferences (such as saved deals)</li>
            <li>Analyze site traffic and usage patterns</li>
          </ul>
          <br />
          When you click an affiliate link on Fitoff and are redirected to a brand's website, that brand and their affiliate network (CJ Affiliate, Awin, or Impact) may place their own cookies on your device. These are governed by the respective brand's and network's own privacy policies.
          <br /><br />
          You can control cookies through your browser settings. Disabling cookies may affect the functionality of some features on our site.
        </Section>

        <Section title="How We Use Your Information">
          We use the information we collect to:
          <ul style={{ marginTop: '10px', paddingLeft: '20px', lineHeight: '2' }}>
            <li>Operate and improve the Fitoff platform</li>
            <li>Analyze which deals and categories are most popular</li>
            <li>Track affiliate commissions through our partner networks</li>
            <li>Ensure the technical functionality of our site</li>
          </ul>
          <br />
          We do not sell, trade, or rent your personal information to third parties.
        </Section>

        <Section title="Third-Party Links">
          Fitoff is a deal aggregator — clicking on a product will redirect you to the brand's official website. Once you leave Fitoff, you are subject to that brand's privacy policy and terms of service. We are not responsible for the privacy practices of third-party websites.
          <br /><br />
          We encourage you to review the privacy policy of any site you visit through our links.
        </Section>

        <Section title="Children's Privacy">
          Fitoff is not directed to children under the age of 13. We do not knowingly collect personal information from children. If you believe a child has provided us with personal information, please contact us and we will promptly delete it.
        </Section>

        <Section title="Your Rights (California Residents)">
          If you are a California resident, you have rights under the California Consumer Privacy Act (CCPA), including:
          <ul style={{ marginTop: '10px', paddingLeft: '20px', lineHeight: '2' }}>
            <li>The right to know what personal information we collect</li>
            <li>The right to request deletion of your personal information</li>
            <li>The right to opt out of the sale of personal information (we do not sell personal information)</li>
            <li>The right to non-discrimination for exercising your privacy rights</li>
          </ul>
          <br />
          To exercise these rights, contact us at the email below.
        </Section>

        <Section title="Changes to This Policy">
          We may update this Privacy Policy from time to time. When we do, we will update the "Last updated" date at the top of this page. We encourage you to review this policy periodically. Continued use of Fitoff after changes are posted constitutes your acceptance of the updated policy.
        </Section>

        <Section title="Contact Us">
          If you have any questions about this Privacy Policy or our data practices, please contact us at:
          <br /><br />
          <strong style={{ color: '#f0f0f0' }}>Fitoff</strong><br />
          fitoff.store<br />
          <span style={{ color: '#ff3c00' }}>contact@fitoff.store</span>
        </Section>

      </div>

      {/* FOOTER */}
      <div style={{
        margin: '0 24px', padding: '20px 0',
        borderTop: '1px solid #242424',
        display: 'flex', justifyContent: 'space-between', alignItems: 'center'
      }}>
        <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '18px', letterSpacing: '2px' }}>
          FIT<span style={{ color: '#ff3c00' }}>OFF</span>
        </div>
        <div style={{ fontSize: '12px', color: '#606060' }}>© {new Date().getFullYear()} Fitoff. All rights reserved.</div>
      </div>

    </div>
  );
}

export default PrivacyPolicy;